import { render, staticRenderFns } from "./ImageCropper.vue?vue&type=template&id=3d580816&scoped=true"
import script from "./ImageCropper.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImageCropper.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ImageCropper.vue?vue&type=style&index=0&id=3d580816&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d580816",
  null
  
)

export default component.exports